/**
 *  获取 templateType
 * 1. 优先 localStorage
 * 2. 兜底 /config.json
 * return templateType
 */
export async function getTemplateType() {
  try {
    const raw = localStorage.getItem('localConfig')
    if (raw) {
      const cfg = JSON.parse(raw)
      if (cfg?.templateType) {
        return cfg.templateType
      }
    }
  } catch (e) {
    console.error('[config] localConfig parse error', e)
  }

  try {
    const response = await fetch('/config.json')
    if (!response.ok) throw new Error('config.json fetch failed')
    const cfg = await response.json()
    return cfg.templateType ?? ''
  } catch (e) {
    console.error('[config] /config.json fetch error', e)
    return ''
  }
}

// 不加await 缓存必有 config.json' 获取 templateType (尽量少用)
export function getTemplateTypeNotAwait() {
  try {
    const raw = localStorage.getItem('localConfig')
    if (!raw) return null
    return JSON.parse(raw)?.templateType || null
  } catch {
    return null
  }
}

// 通用win1
export const templateTypeWin1Flag = () => getTemplateType().then((type) => type === 'win1')

// 通用win2
export const templateTypeWin2Flag = () => getTemplateType().then((type) => type === 'win2')

// 通用win3
export const templateTypeWin3Flag = () => getTemplateType().then((type) => type === 'win3')

// win2的登录注册页面 用户的 icon 特殊显示（手机）
export const templateTypeWin2FlagWithLoginUserIcon = () => getTemplateType().then((type) => type === 'win2')

// win2弹窗   Series  ??
export const templateTypeWin2FlagWithAppSeries = () => getTemplateType().then((type) => type === 'win2')

// 判断 win1 win2 win3 支付弹窗组件
export const templateTypeWin2FlagWithDeposito = async () => {
  const type = await getTemplateType()

  if (type == 'win1') {
    return 'Index50000'
  }

  if (type == 'win2') {
    return 'Index52000'
  }

  if (type == 'win3') {
    return 'Index53000'
  }
}

// 我的页面判断 win1  win2 win3 页面组件
export const templateTypeWin2FlagWithProfile = async () => {
  const type = await getTemplateType()

  if (type == 'win1') {
    return 'Index50000'
  }

  if (type == 'win2') {
    return 'Index52000'
  }

  if (type == 'win3') {
    return 'Index53000'
  }
}

// 弹窗 中 的富文本系统消息公告 win1  win2  组件判定 (无锁机制!!!)
export const templateTypeWin2FlagWithPopSysNotice = () => {
  const type = getTemplateTypeNotAwait()

  if (type == 'win1') {
    return 'Index50000'
  }

  if (type == 'win2') {
    return 'Index52000'
  }

  if (type == 'win3') {
    return 'Index53000'
  }

  return null
}

// --------------------------------------------------------------------- 以下暂时无用------------------------------------------------------------------------------
/**
 *  获取 templateType
 * 1. 优先 localStorage
 * 2. 兜底 /config.json
 * return true false
 */
export async function templateTypeWin1FlagHandler() {
  //  localStorage（不 return false）
  try {
    const raw = localStorage.getItem('localConfig')
    if (raw) {
      const cfg = JSON.parse(raw)
      if (cfg?.templateType) {
        return cfg.templateType === 'win1'
      }
    }
  } catch (e) {
    console.error('[config] localConfig parse error', e)
    // 不 return，继续兜底
  }

  // 2. 兜底 /config.json
  try {
    const res = await fetch('/config.json')
    if (!res.ok) return false

    const cfg = await res.json()
    return cfg.templateType === 'win1'
  } catch (e) {
    console.error('[config] /config.json fetch error', e)
    return false
  }
}
